import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import AuthContext from "../../context/AuthContext";

function EditOrder(props) {
  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const [cat, setcat] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const getorders = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/order/details/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
              order_id: props.order_id,
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setcat(response.data);
          console.log(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    getorders();

    return () => {
      isMounted = false;
    };
  }, []);

  // Define the list of services that should use the total_price as the selling price
  const openPriceServices = [
    "Maintenance Fee",
    "Electrical Accessories",
    "Fiber Installation",
    "Labor Fees",
    "IT Support",
    "Fiber Cable",
  ];

  return (
    <div className="testi">
      <div className="mod">
        <table className="table">
          <thead>
            <tr>
              <th>Item Type</th>
              <th>Item Name</th>
              <th>Quantity</th>
              <th>Selling Price</th>
              <th>Total Price</th>
            </tr>
          </thead>
          <tbody>
            {cat.map((item, index) => (
              <tr key={index}>
                <td>{item.item_type}</td>
                <td>
                  {item.item_type === "Product"
                    ? item.product_name
                    : item.item_type === "Service"
                    ? item.service_name
                    : ""}
                </td>
                <td>{item.quantity}</td>
                <td>
                  {item.item_type === "Product"
                    ? item.product_selling
                    : item.item_type === "Service" &&
                      openPriceServices.includes(item.service_name)
                    ? item.total_price // Use total_price for open price services
                    : item.service_selling}
                </td>
                <td>
                  {(() => {
                    const qty = Number(item.quantity) || 0;

                    // CASE 1 — Open price services: use total_price as-is
                    if (
                      item.item_type === "Service" &&
                      openPriceServices.includes(item.service_name)
                    ) {
                      return item.total_price ?? 0;
                    }

                    // CASE 2 — Product: calculate price if backend is null
                    if (item.item_type === "Product") {
                      const selling = Number(item.product_selling) || 0;
                      return item.total_price ?? qty * selling;
                    }

                    // CASE 3 — Other services (non-open-price)
                    if (item.item_type === "Service") {
                      const selling = Number(item.service_selling) || 0;
                      return item.total_price ?? qty * selling;
                    }

                    return "";
                  })()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default EditOrder;
